import config from 'config';

export default function urlViaCorsProxy(url) {
    return config.CORSProxyUrl + url.replace(/^(https?):\/\//, '$1/');
};



/** WEBPACK FOOTER **
 ** ./src/lib/CORSProxy/index.js
 **/